import { Carousel } from "antd"
import { observer } from "mobx-react"
import React, { useEffect, useRef } from "react"
import CommonStore from "../../Configs/Store/common"
import GenericButton from "../Common/GenericButton"
import RecTable from "../Recommended/RecTable"
import DynamicCard from "./DynamicCard"
import useOnScreen from "./useOnScreen"

const GenericCarousal = observer(
  ({
    stateObserve,
    stateUpdate,
    rootStyle,
    data,
    autoplay = true,
    dots = false,
    arrows = true,
    autoplaySpeed = 5000,
    ArrowComp,
    buttonText,
    buttonClickEvent,
    slidesToShow = 1,
    slidesToScroll = 1,
    effect = "scrollx",
    slideTitle,
    dotPosition = "bottom",
    imgheight0,
    imgwidth0,
    imgheight1,
    imgwidth1,
    ...props
  }) => {
    const handleChange = (e) => {
      CommonStore[stateUpdate](e)
    }
    const slider = useRef()
    const infinity = useRef()

    const isInfinite = useOnScreen(infinity, '100px')

    useEffect(() => {
      slider.current.goTo(CommonStore[stateObserve])
    }, [CommonStore[stateObserve]])

    return (
      <div ref={infinity} className="CarousalRoot" onMouseOver={props.onMouseOver} onMouseLeave={props.onMouseLeave}>
        <Carousel
          className={rootStyle}
          arrows={arrows}
          autoplay={autoplay}
          effect={effect}
          dots={dots}
          dotPosition={dotPosition}
          afterChange={handleChange}
          autoplaySpeed={autoplaySpeed}
          prevArrow={ArrowComp}
          nextArrow={ArrowComp}
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToScroll}
          infinite={isInfinite}
          ref={(ref) => {
            slider.current = ref
          }}
        >
          {data.map((x, i) => (
            <DynamicCard
              key={"GenericCarousal" + new Date().getTime() + "_" + i}
              data={x}
              imgwidth0={imgwidth0}
              imgheight0={imgheight0}
              imgwidth1={imgwidth1}
              imgheight1={imgheight1}
              imgalt={x.iconAlt}
              dot={x.icon ? true : false}
              arrow={false}
              title={x.title ? true : false}
              content={x.content ? true : false}
              icon={x.icon ? true : false}
              wrapperStyle={"cardWrap"}
              titleStyle={"title"}
              contentStyle={"content"}
              // dotStyle={"DynamicCardDotModal"}
              iconStyle={"icon"}
              // titleBodyWrapperStyle={"DynamicCardTitleBodyWrapper"}
              customComp={
                x.table && (
                  <RecTable
                    // divider={false}
                    table={x.table}
                  />
                )
              }
            />
          ))}
        </Carousel>
        {buttonText && <GenericButton title={buttonText} onClick={buttonClickEvent} buttonStyle="RecSliderButton" className="RecSliderButtonRoot" />}
      </div>
    )
  }
)

export default GenericCarousal
